import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  class: "elem-upload-box",
  "dark-class": "elem-upload-box-dark"
}
const _hoisted_2 = ["accept", "multiple"]
const _hoisted_3 = { class: "icon-box" }
const _hoisted_4 = { class: "name" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "preview-title" }, "预览：", -1)
const _hoisted_6 = { class: "upload-preview-list" }
const _hoisted_7 = { class: "upload-file-name" }
const _hoisted_8 = {
  key: 0,
  class: "upload-image-base"
}
const _hoisted_9 = ["src"]
const _hoisted_10 = {
  key: 1,
  class: "upload-video-base"
}
const _hoisted_11 = ["src"]
const _hoisted_12 = {
  key: 2,
  class: "upload-audio-base"
}
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "upload-file-operating" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "upload-file-operating-move" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = ["onClick"]
const _hoisted_19 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_elem_input_object = _resolveComponent("elem-input-object")!
  const _component_elem_icon = _resolveComponent("elem-icon")!
  const _component_ElemIcon = _resolveComponent("ElemIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_elem_input_object, {
      name: $props.name,
      title: $props.title,
      required: $props.required,
      getValue: $options.getFiles
    }, null, 8, ["name", "title", "required", "getValue"]),
    _createElementVNode("input", {
      ref: "upload_input",
      class: "upload-input",
      type: "file",
      accept: $props.accept || $data.types[$props.type].accept,
      multiple: $props.multi,
      onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($options.onSelectFile && $options.onSelectFile(...args)))
    }, null, 40, _hoisted_2),
    _withDirectives(_createElementVNode("div", {
      ref: "upload_drag",
      class: "upload-drag-box",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($options.onClickUpload && $options.onClickUpload(...args)))
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_elem_icon, {
          src: "static/icon/components/elem-upload/",
          name: $props.type
        }, null, 8, ["name"])
      ]),
      _createElementVNode("p", _hoisted_4, "点击上传，或将" + _toDisplayString($data.types[$props.type].name) + "拖拽到此处", 1)
    ], 512), [
      [_vShow, $props.multi || $data.files.length <= 0]
    ]),
    ($data.files.length > 0)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "upload-preview-box",
          style: _normalizeStyle({ 'margin-top': $data.files.length > 0 ? '10px' : '0' })
        }, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.files, (item, idx) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "upload-file-box",
                key: idx
              }, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", null, _toDisplayString(item.name), 1)
                ]),
                ($props.type === 'image')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createElementVNode("img", {
                        src: item.preview || item.url || item.src,
                        class: "upload-image"
                      }, null, 8, _hoisted_9)
                    ]))
                  : ($props.type === 'video')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        ($props.type === 'video')
                          ? (_openBlock(), _createElementBlock("video", {
                              key: 0,
                              src: item.preview || item.url || item.src,
                              class: "upload-video",
                              controls: ""
                            }, null, 8, _hoisted_11))
                          : _createCommentVNode("", true)
                      ]))
                    : ($props.type === 'audio')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                          ($props.type === 'audio')
                            ? (_openBlock(), _createElementBlock("audio", {
                                key: 0,
                                src: item.preview || item.url || item.src,
                                class: "upload-audio",
                                controls: ""
                              }, null, 8, _hoisted_13))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_14, [
                  ($props.type === 'image')
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "upload-file-operating-button",
                        onClick: ($event: any) => ($options.editImageById(item.id))
                      }, [
                        _createVNode(_component_ElemIcon, {
                          src: "static/icon/components/elem-upload/",
                          name: "edit",
                          dark: "edit_white"
                        })
                      ], 8, _hoisted_15))
                    : (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: "upload-file-operating-button operating-button-disable",
                        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($options.editUploadDisable && $options.editUploadDisable(...args)))
                      }, [
                        _createVNode(_component_ElemIcon, {
                          src: "static/icon/components/elem-upload/",
                          name: "edit",
                          dark: "edit_white"
                        })
                      ])),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", {
                      class: "upload-file-operating-button upload-file-operating-move-before",
                      onClick: ($event: any) => ($options.moveUpload(item.id, 'move-before'))
                    }, [
                      _createVNode(_component_ElemIcon, {
                        src: "static/icon/components/elem-upload/",
                        name: "move_left",
                        dark: "move_left_white"
                      })
                    ], 8, _hoisted_17),
                    _createElementVNode("div", {
                      class: "upload-file-operating-button upload-file-operating-move-after",
                      onClick: ($event: any) => ($options.moveUpload(item.id, 'move-after'))
                    }, [
                      _createVNode(_component_ElemIcon, {
                        src: "static/icon/components/elem-upload/",
                        name: "move_right",
                        dark: "move_right_white"
                      })
                    ], 8, _hoisted_18)
                  ]),
                  _createElementVNode("div", {
                    class: "upload-file-operating-button",
                    onClick: ($event: any) => ($options.deleteUpload(item.id))
                  }, [
                    _createVNode(_component_elem_icon, {
                      src: "static/icon/components/elem-upload/",
                      name: "delete",
                      dark: "delete_white"
                    })
                  ], 8, _hoisted_19)
                ])
              ]))
            }), 128))
          ])
        ], 4))
      : _createCommentVNode("", true)
  ]))
}